import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import FadeIn from "@/components/FadeIn";

export interface RelatedLinkItem {
  title: string;
  description: string;
  to: string;
}

interface RelatedLinksProps {
  items: RelatedLinkItem[];
  heading?: string;
}

const RelatedLinks = ({ items, heading = "You might also be interested in" }: RelatedLinksProps) => (
  <section className="section-padding section-alt border-t border-border">
    <div className="container-narrow">
      <FadeIn>
        <h2 className="heading-md text-foreground text-center">{heading}</h2>
      </FadeIn>
      <div className="mt-10 grid gap-4 md:grid-cols-3">
        {items.map((item, i) => (
          <FadeIn key={item.to} delay={i * 0.08}>
            <Link
              to={item.to}
              className="group flex h-full flex-col justify-between rounded-lg border border-border bg-background p-6 transition-colors hover:border-accent"
            >
              <div>
                <h3 className="text-base font-semibold text-foreground">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.description}</p>
              </div>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-accent">
                Learn more
                <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default RelatedLinks;
